(function(){
    'use strict'; 
    angular.module('Services').factory('InvoicedShipmentAuditTrailTable', InvoicedShipmentAuditTrailTable); 
    InvoicedShipmentAuditTrailTable.$inject = [
        'TableLiteFactory',
        '$filter'
    ]; 

    function InvoicedShipmentAuditTrailTable(
        TableLiteFactory,
        $filter
    ){
        return function(auditTrailHistory) {
            let tableData = {
                tableName: 'Shipment Audit Trail', 
                config: {
                    noPagination: true,
                    noHeaders: false,
                    noItemsView: true,
                    noFooter: true
                }, 
                headers: [{
                    label: 'Date & Time',
                    viewName: 'date',
                    width: '150px'
                }, {
                    label: 'User', 
                    viewName: 'user'
                }, {
                    label: 'Details', 
                    viewName: 'details'
                }, {
                    label: 'Change', 
                    viewName: 'change', 
                    width: '200px'
                }],
                data: []
            }; 

            const tableActions = new TableLiteFactory(tableData, {
                serviceCallback: function(callback) {
                    callback({content: auditTrailHistory}); 
                }, 
                callbackFormat: ['success'], 
                postRequestCallback: data => {
                    buildTableData(data);
                },
                postRequestErrorCallback: err => {
                    buildTableData(null);
                },
                defaultFilters: {
                    size: 20,
                    page: 0,
                    sort: 'id,desc'
                }
            });

            function buildTableData(data) {
                tableActions.initializeTableData(data);
                if (!data) {
                    return null;
                }

                angular.forEach(data.content, function (auditTrail) {
                    auditTrail.date = $filter('bbaDate')(auditTrail.date, true);
                    tableData.data.push(auditTrail);
                });
            }

            function updateTableData(auditTrailData){
                tableData.data = auditTrailData; 
            }

            this.updateTableData = updateTableData;
            this.tableData       = tableData;
        } 
    }
})();


// WEBPACK FOOTER //
// ./js/services/tables/accountingTables/InvoicedShipmentAuditTrailTable.js